import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="/" className="flex items-center gap-2 cursor-pointer">
            <div className={`w-10 h-10 flex items-center justify-center rounded-lg ${
              isScrolled ? 'bg-teal-500' : 'bg-white'
            }`}>
              <i className={`ri-shopping-bag-3-line text-2xl ${
                isScrolled ? 'text-white' : 'text-teal-500'
              }`}></i>
            </div>
            <span className={`text-xl font-bold ${
              isScrolled ? 'text-gray-900' : 'text-white'
            }`}>
              PackDeRopa.com
            </span>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            <a 
              href="/" 
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-200'
              }`}
            >
              Inicio
            </a>
            <a 
              href="/catalog" 
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-200'
              }`}
            >
              Catálogo
            </a>
            <a 
              href="/packages" 
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-200'
              }`}
            >
              Packs
            </a>
            <a 
              href="/contact" 
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-200'
              }`}
            >
              Contacto
            </a>
            <a 
              href="/checkout" 
              className="bg-teal-500 hover:bg-teal-600 text-white px-6 py-2 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
            >
              Ver Carrito
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center ${
              isScrolled ? 'text-gray-900' : 'text-white'
            }`}
            aria-label="Toggle menu"
          >
            <i className={`text-2xl ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-200 py-4">
            <div className="flex flex-col gap-4">
              <a href="/" className="text-gray-700 hover:text-teal-600 font-medium cursor-pointer">
                Inicio
              </a>
              <a href="/catalog" className="text-gray-700 hover:text-teal-600 font-medium cursor-pointer">
                Catálogo
              </a>
              <a href="/packages" className="text-gray-700 hover:text-teal-600 font-medium cursor-pointer">
                Packs
              </a>
              <a href="/contact" className="text-gray-700 hover:text-teal-600 font-medium cursor-pointer">
                Contacto
              </a>
              <a 
                href="/checkout" 
                className="bg-teal-500 hover:bg-teal-600 text-white px-6 py-2 rounded-lg font-semibold text-center transition-colors whitespace-nowrap cursor-pointer"
              >
                Ver Carrito
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}